import { ProtectedRoute } from '@/components/auth/protected-route.js';
import { ReportDetailPage } from '@/features/report-detail/components/report-detail-page.js';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/reports/$id')({
  component: ReportPage,
});

function ReportPage() {
  const { id } = Route.useParams();

  return (
    <ProtectedRoute>
      <ReportDetailPage tenantReportId={id} />
    </ProtectedRoute>
  );
}
